import { ElementRef } from "@angular/core";
import { IdName } from "@app-services/oem-dealer.service";

export enum EvalLeadReason {
  EXCHANGE_NEW = 'Troca por novo',
  EXCHANGE_USED = 'Troca por usado',
  SELL_ONLY = 'Venda',
  CONSIGNED = 'Consignado'
}

export class EvalLeadRequest {
  id: string;
  oemDealerId: string;
  evalDealerId: string;
  sellerId: string;
  status: string;

  name: string;
  email: string;
  phoneNumber: string;
  cpf: string;
  reason: string;

  numberPlate: string;
  makeName: string;
  modelName: string;
  trimName: string;
  trimId: string;
  manufactureYear: number;
  modelYear: number;
  km: number;
  fuel: string;
  transmission: string;
  doors: number;
  color: string;
  cityId: string;

  extraKey: boolean;
  carManual: boolean;

  price: number;
}

export class SaveEvalLeadResponse {
  id: string;
  price: number;
  minPrice: number;
  maxPrice: number;
  finalizedAt: Date;
  expiresAt: Date;
  bonus: number;
  success: boolean;
  errorCode: string;
  evalDealers: IdName[];
  currentEvalDealerName: string;
}

export enum EvalLeadResponseErrorCode {
  OK = 'OK',
  PRODUCT_NOT_ENABLED = 'Esta loja está com o Plug-in Raio X desativado ',
  INVALID_DEALER = 'Loja não encontrada',
  NOT_FOUND = 'Avaliação não encontrada'
}

export class CheckNumberPlateEvalLeadRequest {
  evalLeadId: string;
  numberPlate: string;
  oemDealerId: string;
  evalDealerId: string;
}

export class CheckNumberPlateEvalLeadResponse {
  status: string;
  numberPlate: string;
  makeName: string;
  modelName: string;
  trimName: string;
  trimId: string;
  modelId: string;
  color: string;
  fuel: string;
  doors: number;
  transmission: string;
  manufactureYear: number;
  modelYear: number;
}
